const quizData = [
  {
    quizText:
      "Now that you understand the logic behind an SGA report, let's take it a step further.\n\nAnswer these questions to gain a deeper understanding of the objectives of the SGA.",
    quizConsigne: " Click on the answer you think is right.",
    buttonLabel: "CONTINUE",
  },
];

export default quizData;
